import React from 'react';

const CSAT_OPTIONS = [
  { value: 1, color: '#c41e3a' },
  { value: 2, color: '#f97316' },
  { value: 3, color: '#facc15' },
  { value: 4, color: '#86efac' },
  { value: 5, color: '#22c55e' },
] as const;

export interface CroissantCsatSliderProps {
  rating: number;
  onChange: (rating: number) => void;
  disabled?: boolean;
}

export const CroissantCsatSlider: React.FC<CroissantCsatSliderProps> = ({
  rating,
  onChange,
  disabled = false,
}) => {
  const valor = Math.min(5, Math.max(0, Math.round(rating)));

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <div
        role='group'
        aria-label='Avaliação de 1 a 5 — pouco satisfeito a muito satisfeito'
        style={{
          display: 'flex',
          width: '100%',
          maxWidth: 420,
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 6,
          flexWrap: 'nowrap',
        }}
      >
        {CSAT_OPTIONS.map(item => {
          const n = item.value;
          const selecionado = valor === n;
          return (
            <button
              key={n}
              type='button'
              disabled={disabled}
              onClick={() => onChange(n)}
              aria-label={`Nota ${n} de 5`}
              aria-pressed={selecionado}
              style={{
                width: 52,
                height: 52,
                flexShrink: 0,
                borderRadius: '50%',
                border: selecionado ? '3px solid #1f2937' : '2px solid transparent',
                background: item.color,
                color: '#fff',
                fontSize: 22,
                fontWeight: 700,
                cursor: disabled ? 'not-allowed' : 'pointer',
                lineHeight: 1,
                boxShadow: selecionado
                  ? '0 0 0 2px rgba(31,41,55,0.15)'
                  : '0 2px 4px rgba(0,0,0,0.12)',
                opacity: disabled ? 0.55 : 1,
                transition: 'transform 0.12s ease, box-shadow 0.12s ease',
              }}
            >
              {n}
            </button>
          );
        })}
      </div>

      <div
        style={{
          display: 'flex',
          width: '100%',
          maxWidth: 420,
          justifyContent: 'space-between',
          marginTop: 10,
          padding: '0 2px',
        }}
      >
        <span
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: '#6b7280',
            lineHeight: 1.2,
          }}
        >
          Pouco satisfeito
        </span>
        <span
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: '#6b7280',
            lineHeight: 1.2,
            textAlign: 'right',
          }}
        >
          Muito satisfeito
        </span>
      </div>
    </div>
  );
};
